export const mapDataForBackend = (customer) => ({
  firstName: customer.givenName,
  lastName: customer.familyName,
  phoneNumber: customer.workNumber,
});
